import { GA4_DEBUG_MODE } from '@/constants'

export default defineNuxtPlugin(nuxtApp => {
	const { initialize } = useGA4EventQueue()
	const { initializeVisitor } = useVisitorTracking()

	// Initialize visitor tracking immediately (lightweight)
	initializeVisitor()

	const consoleLog = (...args: any[]) => {
		if (import.meta.client && GA4_DEBUG_MODE) {
			console.log('[GA4]', ...args)
		}
	}

	const consoleError = (...args: any[]) => {
		if (import.meta.client && GA4_DEBUG_MODE) {
			console.error('[GA4]', ...args)
		}
	}

	// Simplified initialization with broader interaction detection
	let initialized = false

	const initGA4 = async () => {
		if (initialized) return
		initialized = true

		try {
			await initialize()
			consoleLog('GA4 initialized')
		} catch (error) {
			consoleError('[GA4] Initialization failed:', error)
		}
	}

	// Initialize on any user interaction (broader scope)
	const interactionEvents = [ 'click', 'scroll', 'touchstart', 'keypress', 'mousemove' ]

	const handleInteraction = () => {
		initGA4()
		// Remove all listeners after initialization
		interactionEvents.forEach(event => {
			document.removeEventListener(event, handleInteraction)
		})
	}

	// Add listeners for all interaction types
	interactionEvents.forEach(event => {
		document.addEventListener(event, handleInteraction, {
			once: true,
			passive: true,
			capture: true
		})
	})

	// Fallback: initialize after 10 seconds if no interaction
	setTimeout(() => initGA4(), 10000)

	// Global error tracking
	nuxtApp.hook('vue:error', error => {
		const { trackError } = useGA4Tracking()
		trackError(
			error instanceof Error ? error.message : 'Unknown error',
			'vue_global',
			false
		)
	})
})
